module.exports = __webpack_public_path__ + "static/media/month_05.64a617ae.png";